// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoading_container__1PdEG cy-3","message":"PageLoading_message__2F9Hi text-subheading text-reset"};